
export const customStyle = {
    option: (base, { isSelected, isDisabled  }) => {
        let newbase = {
            ...base,
            backgroundColor: isSelected ? '#5757fe' : '#fff',
            color: isSelected ? '#fff' : '#000',
            cursor: isDisabled ? 'not-allowed' : 'default',
            '&:hover': {
                color: isSelected ? '#fff' : '#000',
                backgroundColor: isSelected ? '#5757fe' : '#5757fe22'
            },
            '&:focus-visible': {
                color: '#fff'
            },
            ':active': {
                color: '#ffffff',
                backgroundColor: '#5757fe'
            },
            '&:active': {
                color: '#ffffff',
                backgroundColor: '#5757fe'
            },
            '&:target': {
                color: '#fff'
            }
        }
        return newbase
    },
    valueContainer: style => ({
        ...style,
        padding: '5px'
    }),
    container: style => ({
        ...style,
        width: '100%'
    }),
    multiValue: style => ({
        ...style,
        borderRadius: '20px',
        color: '#ffffff',
        backgroundColor: '#5757fe'
    }),
    multiValueLabel: style => ({
        ...style,
        color: '#fff',
        paddingTop: '9px',
        paddingBottom: '9px',
        paddingLeft: '15px',
        paddingRight: '9px',
        fontSize: '70%',
        transition: 'all 0.3s ease'
    }),
    multiValueRemove: style => ({
        ...style,
        color: 'white',
        backgroundColor: '#5757fe',
        borderRadius: '20px',
        height: '20px',
        marginTop: '8px',
        marginRight: '10px',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#5757fe'
        }
    }),
    indicatorSeparator: style => ({
        ...style,
        display: 'none'
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 3,
    }),
}